import React from "react";

import { useTranslation } from "react-i18next";

import { OfferHistoryPeriodTags } from "@features/offer/shared/event/offer-history/OfferHistoryPeriodTags";
import { Event } from "@gp/models";
import useDayAndTime from "@hooks/useDayAndTimeFromEventStartTime";
import { observer } from "mobx-react";

import TopEventTag from "../../common/TopEventTag";

export const StartTime = observer(function StartTime(props: {
	event: Event;
	className: string;
	isAdditionalOfferVisible?: boolean;
	isAfterExtraTime?: boolean;
	isAfterPenalties?: boolean;
}) {
	const { t } = useTranslation();

	const { event, className, isAfterExtraTime, isAfterPenalties } = props;
	const { day, time } = useDayAndTime(event.startTime, true);

	const hasTags =
		!props.isAdditionalOfferVisible || isAfterExtraTime || isAfterPenalties;

	return (
		<div className={className}>
			<div className="offer__day__date">{day}</div>
			<strong className="offer__day__time">{time}</strong>

			{hasTags && (
				<div className="offer__tags">
					{!props.isAdditionalOfferVisible &&
					props.event.hasLiveCoverage &&
					!props.event.isLive ? (
						<div className="offer__tag offer__tag--live tag tag--tny tag--live--ghost tag--bolder">
							{t<string>("COMMON.LIVE")}
						</div>
					) : null}

					{!props.isAdditionalOfferVisible && (
						<TopEventTag
							className="offer__tag offer__tag--top u-icon u-icon--sml u-icon--top--str u-color--rate--low"
							event={props.event}
						/>
					)}

					<OfferHistoryPeriodTags
						eventId={event.id}
						isAfterExtraTime={isAfterExtraTime ?? false}
						isAfterPenalties={isAfterPenalties ?? false}
						tagBlock="offer__tag"
						idPrefix="offer-row"
					/>
				</div>
			)}
		</div>
	);
});
